module.exports = __webpack_public_path__ + "media/images/lb/000-1a47563b8f75f52686aa6411f39d21d1.svg";